import _toConsumableArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsxs, jsx } from 'react/jsx-runtime';
import { Button } from '@design-system/button';
import { CheckboxField } from '@design-system/checkbox-field';
import { ErrorMessage } from '@design-system/error-message';
import { Typography } from '@design-system/typography';
import classNames from 'classnames';
import { useState, useEffect } from 'react';
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z = ".checkbox-group-module_link__h4OTe {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.checkbox-group-module_label__tXf6q {\n  color: var(--phx-textColor, #101010);\n}\n\n.checkbox-group-module_errorMessage__mKXM3 {\n  margin: var(--cds-space-2) 0;\n}\n\n.checkbox-group-module_errorMessage__mKXM3.cds-error-icon {\n  margin: 0px;\n  width: var(--cds-icon-size-xs);\n  height: var(--cds-icon-size-xs);\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNoZWNrYm94LWdyb3VwLm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsMEJBQTBCO0VBQzFCLGVBQWU7QUFDakI7O0FBRUE7RUFDRSxvQ0FBb0M7QUFDdEM7O0FBRUE7RUFDRSw0QkFBNEI7QUFDOUI7O0FBQ0E7RUFDRSxXQUFXO0VBQ1gsOEJBQThCO0VBQzlCLCtCQUErQjtBQUNqQyIsImZpbGUiOiJjaGVja2JveC1ncm91cC5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5saW5rIHtcbiAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG4gIGN1cnNvcjogcG9pbnRlcjtcbn1cblxuLmxhYmVsIHtcbiAgY29sb3I6IHZhcigtLXBoeC10ZXh0Q29sb3IsICMxMDEwMTApO1xufVxuXG4uZXJyb3JNZXNzYWdlIHtcbiAgbWFyZ2luOiB2YXIoLS1jZHMtc3BhY2UtMikgMDtcbn1cbi5lcnJvck1lc3NhZ2U6Z2xvYmFsKC5jZHMtZXJyb3ItaWNvbikge1xuICBtYXJnaW46IDBweDtcbiAgd2lkdGg6IHZhcigtLWNkcy1pY29uLXNpemUteHMpO1xuICBoZWlnaHQ6IHZhcigtLWNkcy1pY29uLXNpemUteHMpO1xufSJdfQ== */";
var styles = {
  "link": "checkbox-group-module_link__h4OTe",
  "label": "checkbox-group-module_label__tXf6q",
  "errorMessage": "checkbox-group-module_errorMessage__mKXM3"
};
styleInject(css_248z);
var CheckboxGroup = function CheckboxGroup(_ref) {
  var name = _ref.name,
    onChange = _ref.onChange,
    classes = _ref.classes,
    defaultValue = _ref.defaultValue,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    errorMessage = _ref.errorMessage;
  var _useState = useState(defaultValue || []),
    _useState2 = _slicedToArray(_useState, 2),
    values = _useState2[0],
    setValues = _useState2[1];
  useEffect(function () {
    onChange({
      name: name,
      value: values
    });
  }, [values]);
  var handleCheckbox = function handleCheckbox(e) {
    if (e.target.checked) {
      setValues(function (prev) {
        return [].concat(_toConsumableArray(prev), [e.target.value]);
      });
    } else {
      setValues(values.filter(function (item) {
        return item !== e.target.value;
      }));
    }
  };
  var createCheckBoxLabel = function createCheckBoxLabel(labels) {
    return labels.map(function (item) {
      var key = item.value.replace(/\s/g, '_');
      var onClickFunction = function onClickFunction(e) {
        e.preventDefault();
        item.onClick();
      };
      return typeof item.onClick === 'function' ? jsx(Button, Object.assign({
        variant: "subtle",
        role: "button",
        className: styles.link,
        onClick: onClickFunction,
        tabIndex: 0
      }, {
        children: jsx(Typography, {
          variant: "body",
          tag: "span",
          size: "m",
          weight: "bold",
          className: styles.label,
          content: item.value
        }, key)
      })) : jsx(Typography, {
        variant: "body",
        tag: "span",
        size: "m",
        className: styles.label,
        content: item.value
      }, key);
    });
  };
  return jsxs("div", Object.assign({
    className: classNames(classes === null || classes === void 0 ? void 0 : classes.container, 'checkbox-group__container'),
    "data-testid": "checkbox-group-container"
  }, {
    children: [options.map(function (item) {
      return jsx(CheckboxField, {
        isDisabled: item.isDisabled,
        id: "".concat(name, "-").concat(item.key),
        name: name,
        "data-testid": "".concat(name, "-").concat(item.key),
        label: item.labels ? createCheckBoxLabel(item.labels) : undefined,
        value: item.key,
        onChange: handleCheckbox,
        isHidden: item.hideCheckbox,
        checked: values.includes(item.key)
      }, "".concat(name, "-").concat(item.key));
    }), errorMessage ? jsx(ErrorMessage, {
      className: styles.errorMessage,
      message: errorMessage
    }) : null]
  }));
};
export { CheckboxGroup };